import { defineStore } from "pinia";
import { AddCustomerToDossierState } from "@/enums/AddCustomerToDossierState";
import type { MessageLabel } from "@/models/MessageLabel";
import type { Dossier } from "@/generatedApi";

export const useLoadingStore = defineStore("loading", {
	state: () => ({
		unsavedChanges: false,

		loadingDossier: false,
		selectedDossier: null as Dossier | null,

		creatingDossier: false,
		createDossierFailed: false,
		createDossierMessage: "",

		setSelectedDossierFailed: false,
		setSelectedDossierMessage: "",

		dossierDeleteFailed: false,
		dossierDeleteMessage: "",
		deletingDossier: false,

		fetchingUserOfADossier: false,
		fetchingUserOfADossierMessage: "",
		fetchingUserOfADossierFailed: false,

		addingUserToADossier: false,
		addingUserToDossierState: AddCustomerToDossierState.SAVED,
		addingUserToADossierMessage: "",

		creatingNewHdnRequest: false,
		creatingNewHdnRequestMessage: "",
		creatingNewHdnRequestFailed: false,

		transferringDossierOwnership: false,
		transferDossierOwnershipFailed: false,

		dossiersMessage: null as MessageLabel,
	}),
});
